// extracted by mini-css-extract-plugin
export default {"phoneNumber":"Phone_phoneNumber__rsQec","fastCode":"Phone_fastCode__JeKOH","centerAlign":"Phone_centerAlign__PQTyN"};